import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=e45522b2&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=e45522b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45522b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e45522b2')) {
      api.createRecord('e45522b2', component.options)
    } else {
      api.reload('e45522b2', component.options)
    }
    module.hot.accept("./ProfileData.vue?vue&type=template&id=e45522b2&scoped=true&", function () {
      api.rerender('e45522b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/selectTeam/ProfileData.vue"
export default component.exports